import { useDigitalGiftCardBalanceQuery } from '@fhs/payments';

import { usePaymentMethodStore } from '../payment';

export function useSelectedGiftCard() {
  const selectedPaymentMethod = usePaymentMethodStore(state => state.selectedPaymentMethod);
  const selectedGiftCardAccountId = usePaymentMethodStore(state => state.selectedGiftCardAccountId);
  const userAccountsData = usePaymentMethodStore(state => state.userAccountsData);

  // Fetch real-time balance from GetGiftCardBalance API
  const { data: balanceData } = useDigitalGiftCardBalanceQuery();

  if (selectedPaymentMethod !== 'giftCard') {
    return null;
  }

  const accounts = userAccountsData.userAccounts?.accounts ?? [];
  const account = selectedGiftCardAccountId
    ? accounts.find(
        (acc: any) =>
          acc?.accountIdentifier === selectedGiftCardAccountId ||
          acc?.fdAccountId === selectedGiftCardAccountId
      )
    : accounts.find((acc: any) => acc?.giftCard);

  const giftCard = account?.giftCard;

  if (!giftCard) {
    return null;
  }

  // Return gift card with real-time balance from API (no fallback to stale DB value)
  return {
    ...giftCard,
    currentBalance: balanceData?.currentBalance,
  };
}
